exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".image_uploader {\n  width: 100%;\n  height: 200px;\n  border: 2px dashed #999999;\n  border-radius: 5px;\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/imageUploader.sass
// module id = 1361
// module chunks = 0